module.exports = __webpack_public_path__ + "static/media/dvd-list03.63f06433.jpg";